import { postRequest } from "../config/axiosConfig";
import { SubmitAnswersRequest } from "../interfaces";

class SubmitAnswersService {
    baseUrl: string;

    constructor() {
        this.baseUrl = "answers/" + process.env.REACT_APP_WEBSITE_BRAND;
    }
    async submitAnswers(body: SubmitAnswersRequest) {
        return await postRequest(`${this.baseUrl}`, body);
    }
}

export default SubmitAnswersService;
